import React from 'react';
import {Table} from 'semantic-ui-react';
import moment from 'moment';

const TableRecord = ({records = []}) => {
  if (records.length === 0) {
    return <div style={{'padding': '20px'}}>
      <h3 style={{'textAlign': 'left'}}>No hay registros</h3>
    </div>;
  }

  return (
    <div style={{'marginRight': 20, 'marginLeft': 20}}>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ESTADO</Table.HeaderCell>
            <Table.HeaderCell>VENDIDO A</Table.HeaderCell>
            <Table.HeaderCell>USUARIO</Table.HeaderCell>
            <Table.HeaderCell>FECHA</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {records.map((record) => (
            <Table.Row key={record.id}>
              <Table.Cell>{record.status}</Table.Cell>
              <Table.Cell>{record.sell}</Table.Cell>
              <Table.Cell>{record.user}</Table.Cell>
              <Table.Cell>{moment(record.date).format('DD/MM/YYYY')}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  
  );
};

export default TableRecord;
